export const AppImages = {
  // icAppLogo: require("../../assets/icAppLogo.png"),
  icAppLogo: require("../../assets/icAppNewLogo.png"),
  icCardBg: require("../../assets/icCardBg.svg"),
  walkthroughImage: require("../../assets/homeWalkthroughImage.svg"),
  UpgradeBtnBg: require("../../assets/UpgradeBtnBg.png"),
  icLoadingScreenArrow: require("../../assets/icLoadingScreenArrow.png"),
  icLoadingScreenBG: require("../../assets/icLoadingScreenBG.png"),
  icImageBlur: require("../../assets/icImageBlur.png"),
  icRightTranspaerntBlueCircle: require("../../assets/icRightTranspaerntBlueCircle.png"),
  icArrowExpandRound: require("../../assets/icArrowExpandRound.svg"),
  icArrowRight: require("../../assets/icArrowRight.png"),
  icArrowLeft: require("../../assets/icArrowLeft.svg"),
  imgLoginBG: require("../../assets/Images/imgLoginBG.png"),
  icIconBack: require("../../assets/icIconBack.png"),
  icArrowDown: require("../../assets/icArrowDown.png"),
  imgBottomShadow: require("../../assets/Images/imgBottomShadow.png"),
  imgTopShadow: require("../../assets/Images/imgTopShadow.png"),
  imgBottomLeftShadow: require("../../assets/Images/imgBottomLeftShadow.png"),
  imgTopRightGame: require("../../assets/Images/imgTopRightGame.png"),
  whiteCircle: require("../../assets/Images/whiteCircle.png"),
  imgAboutBG: require("../../assets/Images/imgAboutBG.png"),
  imgBottomArrow: require("../../assets/Images/imgBottomArrow.png"),
  icVisa: require("../../assets/Images/icVisa.png"),
  icPayPal: require("../../assets/Images/icPayPal.png"),
  upgradeToPro: require("../../assets/Images/upgradeToPro.png"),
  imgDemo: require("../../assets/Images/demo.jpeg"),
  icDemoImage: require("../../assets/Images/icDemoImage.svg"),
  icFreeFireGame: require("../../assets/Images/icFreeFireGame.png"),
  purpleComputer: require("../../assets/Images/purpleComputer.svg"),
  screeningImg: require("../../assets/Images/screeningImg.svg"),
  greatSquadPhoto: require("../../assets/Images/greatSquadPhoto.svg"),
  icComplete: require("../../assets/icons/icComplete.svg"),
  icCompleteGreen: require("../../assets/icons/icCompleteGreen.svg"),

  icMicOn: require("../../assets/icMicOn.svg"),
  icMicOff: require("../../assets/icMicOff.svg"),
  icInstagram: require("../../assets/icInstagram.png"),
  icFacebook: require("../../assets/icFacebook.png"),
  icGoogle: require("../../assets/icGoogle.png"),
  icApple: require("../../assets/icApple.png"),
  icInstagramBG: require("../../assets/icInstagramBG.png"),
  icFemaleAvatar: require("../../assets/icFemaleAvatar.png"),
  icCheckedBlue: require("../../assets/icCheckedBlue.png"),
  icCheckedGreen: require("../../assets/icCheckedGreen.svg"),
  icLoadingScreenRemoteBG: require("../../assets/icLoadingScreenRemoteBG.png"),
  icLogo: require("../../assets/icLogo.svg"),
  icLogos: require("../../assets/Home-Logo.svg"),
  icNewSideBarLogo: require("../../assets/icNewSideBarLogo.svg"),
  icVsPurple: require("../../assets/icVsPurple.png"),
  icTriangle: require("../../assets/icTriangle.svg"),
  icBlueLine: require("../../assets/icBlueLine.png"),
  icName: require("../../assets/icName.svg"),
  icInfo: require("../../assets/icInfo.svg"),
  icVerified: require("../../assets/icVerified.svg"),
  icVerifiedNew: require("../../assets/icVerifiedNew.svg"),
  icVerify: require("../../assets/icVerify.svg"),

  icReloadIcon: require("../../assets/icReloadIcon.png"),
  icCoinBox: require("../../assets/icCoinBox.svg"),
  icShareIcon: require("../../assets/icShareIcon.png"),
  icShareBlackIcon: require("../../assets/icShareBlackIcon.svg"),
  icFavoriteIcon: require("../../assets/icFavoriteIcon.png"),
  icPencil: require("../../assets/icPencil.png"),
  icPlusIcon: require("../../assets/icPlusIcon.png"),
  icMinusIcon: require("../../assets/icMinusIcon.svg"),
  icGrayPlusIcon: require("../../assets/icGrayPlusIcon.svg"),
  icPlusWithRound: require("../../assets/icPlusWithRound.svg"),
  thumbnailIcon: require("../../assets/Images/thumbnailIcon.png"),
  imgVS: require("../../assets/Images/imgVS.png"),
  icVSNew: require("../../assets/Images/icVSNew.svg"),
  icnChecked: require("../../assets/Images/icnChecked.png"),
  icnUnChecked: require("../../assets/Images/icnUnChecked.png"),
  icEventEdit: require("../../assets/Images/icEventEdit.png"),
  icThumbUp: require("../../assets/Images/icThumbUp.png"),
  icThumbUpBlack: require("../../assets/Images/icThumbUpBlack.svg"),
  icThumbDownBlack: require("../../assets/Images/icThumbDownBlack.svg"),
  icThumbDown: require("../../assets/Images/icThumbDown.png"),
  imgUserChallenge: require("../../assets/Images/imgUserChallenge.png"),

  // icPrivate: require("../../assets/icPrivate.svg"),
  // icPublic: require("../../assets/icPublic.svg"),
  icInfoCircle: require("../../assets/information-circle.svg"),
  icDailyCoins: require("../../assets/icDailyCoins.svg"),
  icQuestionInfo: require("../../assets/icQuestionInfo.svg"),
  icPrivateLogo: require("../../assets/exclusive-logo.svg"),
  icPublicLogo: require("../../assets/call-out-logo.svg"),
  icPrivate: require("../../assets/exclusive.svg"),
  icPublic: require("../../assets/call-out.svg"),
  icDateCalendar: require("../../assets/icDateCalendar.png"),
  icCalender: require("../../assets/icCalender.svg"),
  icFlagPakistan: require("../../assets/icFlagPakistan.png"),
  icEdit: require("../../assets/icEdit.png"),
  icImageEdit: require("../../assets/icImageEdit.svg"),
  icWonDollarIcon: require("../../assets/icWonDollarIcon.svg"),
  icWhiteDollarIcon: require("../../assets/tokensIcon.svg"),
  icQuestion: require("../../assets/icQuestion.svg"),
  icEmoji: require("../../assets/icEmoji.svg"),
  icTopDownArrow: require("../../assets/icTopDownArrow.png"),
  icNeedHelp: require("../../assets/icNeedHelp.png"),
  icPaymentmethod: require("../../assets/icPaymentmethod.png"),
  icLearnAboutToken: require("../../assets/icLearnAboutToken.png"),
  icDragNDrop: require("../../assets/icDragNDrop.png"),

  icCloseWhite: require("../../assets/Images/icCloseWhite.png"),
  icSocialFacebook: require("../../assets/Images/icSocialFacebook.svg"),
  icSocialInsta: require("../../assets/Images/icSocialInsta.svg"),
  icSocialSnapChat: require("../../assets/Images/icSocialSnapChat.svg"),
  icSocialTiktok: require("../../assets/Images/icSocialTiktok.svg"),
  icSocialTwitter: require("../../assets/Images/icSocialTwitter.svg"),
  icSocialX: require("../../assets/Images/icSocialX.svg"),
  icSocialWhatsapp: require("../../assets/Images/icSocialWhatsapp.svg"),
  icLinkSocial: require("../../assets/Images/icLinkSocial.png"),
  icUserChecked: require("../../assets/Images/icUserChecked.png"),
  icSocialYoutube: require("../../assets/Images/icSocialYoutube.svg"),
  icSocialTwitch: require("../../assets/Images/icSocialTwitch.svg"),
  icSocialDiscord: require("../../assets/Images/icSocialDiscord.svg"),
  icLinkedIn: require("../../assets/Images/icLinkedIn.svg"),
  icSocialFacebookSvg: require("../../assets/Images/icSocialFacebook.svg"),
  // Medal

  icPlatinumMedal: require("../../assets/medal/icPlatinumMedal.png"),
  icGoldMedal: require("../../assets/medal/icGoldMedal.png"),
  icSilverMedal: require("../../assets/medal/icSilverMedal.png"),
  icBronzeMedal: require("../../assets/medal/icBronzeMedal.png"),
  icCoinMedal: require("../../assets/medal/icCoinMedal.png"),
  icNewMedal: require("../../assets/medal/icNewMedal.svg"),
  icCoinKo: require("../../assets/new/coin.png"),
  icTokenKo: require("../../assets/new/token.png"),

  // Coin
  icSilverCoin: require("../../assets/new/token.png"),
  icGoldCoin: require("../../assets/new/coin.png"),

  // Belt

  icPlatinumBelt: require("../../assets/new/platinum.png"),
  icGoldBelt: require("../../assets/new/gold.png"),
  icSilverBelt: require("../../assets/new/silver.png"),
  icBronzeBelt: require("../../assets/new/bronze.png"),
  icCoinBelt: require("../../assets/new/coin.png"),

  // Brands
  COCACOLA_BRAND: require("../../assets/KO_BRANDS/COCACOLA_BRAND.svg"),
  MOCKINGBOT_BRAND: require("../../assets/KO_BRANDS/MOCKINGBOT_BRAND.svg"),
  PHICOMM_BRAND: require("../../assets/KO_BRANDS/PHICOMM_BRAND.svg"),
  WIREDCRAFT_BRAND: require("../../assets/KO_BRANDS/WIREDCRAFT_BRAND.svg"),

  // Sponsors
  Ko_Sponser_2: require("../../assets/sponsers/Ko_Sponser_2.svg"),
  Ko_Sponser_3: require("../../assets/sponsers/Ko_Sponser_3.png"),
  Ko_Sponser_4: require("../../assets/sponsers/Ko_Sponser_4.png"),
  Ko_Sponser_5: require("../../assets/sponsers/Ko_Sponser_5.png"),
  Ko_Sponser_6: require("../../assets/sponsers/Ko_Sponser_6.png"),
  Ko_Sponser_7: require("../../assets/sponsers/Ko_Sponser_7.png"),
  Ko_Sponser_8: require("../../assets/sponsers/Ko_Sponser_8.png"),
  Ko_Sponser_9: require("../../assets/sponsers/Ko_Sponser_9.png"),
  Ko_Sponser_10: require("../../assets/sponsers/Ko_Sponser_10.png"),
  Ko_Sponser_11: require("../../assets/sponsers/Ko_Sponser_11.png"),
  Ko_Sponser_unity_radio: require("../../assets/sponsers/Ko_Sponser_unity_radio.png"),

  imgSilverBelt: require("../../assets/Images/imgSilverBelt.png"),
  imgGoldBelt: require("../../assets/Images/imgGoldBelt.png"),
  imgPlatinumBelt: require("../../assets/Images/imgPlatinumBelt.png"),
  imgBronzeBelt: require("../../assets/Images/imgBronzeBelt.png"),
  icnDollarDotted: require("../../assets/Images/icnDollarDotted.png"),
  icnAddToken: require("../../assets/Images/icnAddToken.png"),
  icnArrowBlack: require("../../assets/Images/icnArrowBlack.png"),
  icnTokenToDollar: require("../../assets/Images/icnTokenToDollar.png"),
  icnDownPrice: require("../../assets/Images/icnDownPrice.png"),
  icnUpPrice: require("../../assets/Images/icnUpPrice.png"),
  arrowUp: require("../../assets/arrowUp.png"),
  icnBlackDownPrice: require("../../assets/Images/icnBlackDownPrice.svg"),
  icnBlackUpPrice: require("../../assets/Images/icnBlackUpPrice.svg"),
  icMessage: require("../../assets/icMessage.png"),
  icshare: require("../../assets/icshare.svg"),
  icedit: require("../../assets/icedit.svg"),
  icLikeWithFire: require("../../assets/icLikeWithFire.svg"),
  icLike: require("../../assets/icLike.svg"),
  icLikesGif: require("../../assets/icLikesGif.gif"),
  JosebImage: require("../../assets/JosebImage.png"),
  GirlImg: require("../../assets/GirlImg.png"),
  icShareCrop: require("../../assets/icShareCrop.png"),
  icNotificationbing: require("../../assets/icNotificationbing.png"),
  icEye: require("../../assets/icEye.png"),
  youtubeStream: require("../../assets/youtubeStream.svg"),
  icYoutubeStreaming: require("../../assets/icYoutubeStreaming.svg"),
  twitchStream: require("../../assets/twitchStream.svg"),
  icCheckGreen: require("../../assets/icCheckGreen.svg"),
  icCheckWhite: require("../../assets/icCheckWhite.svg"),
  icLock: require("../../assets/icLock.svg"),

  icEyeClose: require("../../assets/icEyeClose.svg"),
  icWhiteEye: require("../../assets/icWhiteEye.svg"),
  icGift: require("../../assets/icGift.png"),
  icThemeGift: require("../../assets/icThemeGift.svg"),
  icUpload: require("../../assets/icUpload.png"),
  icChatWhite: require("../../assets/icChatWhite.png"),
  icVS: require("../../assets/icVS.png"),
  whiteVs: require("../../assets/whiteVs.png"),
  whiteVsSvg: require("../../assets/whiteVsSvg.svg"),
  vsWhite: require("../../assets/vsWhite.png"),
  vsUpgrade: require("../../assets/icLogo.svg"),
  icVsBlack: require("../../assets/icVsBlack.svg"),
  icthumbsUp: require("../../assets/icthumbsUp.png"),
  icthumbsDown: require("../../assets/icthumbsDown.png"),
  // icSearch: require("../../assets/icSearch.png"),
  icPlus: require("../../assets/icPlus.png"),
  icPin: require("../../assets/icPin.svg"),
  icDelete: require("../../assets/icDelete.svg"),
  icRedDelete: require("../../assets/icRedDelete.svg"),
  icRoundBottom: require("../../assets/icRoundBottom.svg"),
  icTick: require("../../assets/icTick.png"),
  icCancel: require("../../assets/icCancel.png"),
  icLinkMedia: require("../../assets/icLinkMedia.png"),
  arrowDown: require("../../assets/arrowDown.png"),
  arrowRight: require("../../assets/arrowRight.png"),
  icSignUpBGWeb: require("../../assets/icSignUpBGWeb.png"),
  icSignUpBGMobile: require("../../assets/icSignUpBGMobile.png"),
  icDummyUserPic: require("../../assets/icDummyUserPic.png"),
  icDummyUserGroup: require("../../assets/icDummyUserGroup.svg"),
  icShield: require("../../assets/icShield.svg"),
  ThreeLines: require("../../assets/ThreeLines.svg"),
  SettingIcon: require("../../assets/Setting-icon.svg"),
  WhiteThreeLines: require("../../assets/WhiteThreeLines.svg"),
  Placeholder: require("../../assets/placeholder.svg"),

  // icons
  icNotificationBing: require("../../assets/icons/notification-updated-icon.svg"),
  icEvent: require("../../assets/icons/icEvent.png"),
  icTournament: require("../../assets/icons/icTournament.png"),
  icUpArrow: require("../../assets/icons/icUpArrow.png"),
  icDownArrow: require("../../assets/icons/icDownArrow.png"),
  icDownLineArrow: require("../../assets/icons/icDownLineArrow.svg"),
  icDownload: require("../../assets/icons/icDownload.svg"),
  icRoundDownArrow: require("../../assets/icons/icRoundDownArrow.svg"),
  icRoundUpArrow: require("../../assets/icons/icRoundUpArrow.svg"),
  icUpLineArrow: require("../../assets/icons/icUpLineArrow.svg"),
  icRightLineArrow: require("../../assets/icons/icRightLineArrow.svg"),
  icBlockLeftArrow: require("../../assets/icons/arrow-block-left.svg"),
  icBlockRightArrow: require("../../assets/icons/arrow-block-right.svg"),
  icSwitchOff: require("../../assets/icons/icSwitchOff.png"),
  icSwitchOn: require("../../assets/icons/icSwitchOn.png"),
  icExclusiveEvent: require("../../assets/icons/icExclusiveEvent.svg"),
  icSwitchOnWhite: require("../../assets/icons/icSwitchOnWhite.svg"),
  icSwitchOffWhite: require("../../assets/icons/icSwitchOffWhite.svg"),

  icProfilePlaceHolder: require("../../assets/icons/icProfilePlaceHolder.svg"),
  icRightIcon: require("../../assets/icons/icRightIcon.svg"),
  icSearch: require("../../assets/icons/Search-icon.svg"),
  icFilter: require("../../assets/icons/icFilter.svg"),
  icClose: require("../../assets/icons/Close-icon.svg"),
  icBoldClose: require("../../assets/icons/icBoldClose.svg"),
  icSearchWhite: require("../../assets/icons/icSearchWhite.svg"),
  icSearchGray: require("../../assets/icons/icSearchGray.svg"),
  icWallet: require("../../assets/icons/icWallet.png"),
  // icWallet: require("../../assets/icons/icWallet.png"),
  icMessageSvg: require("../../assets/icons/icMessageSvg.svg"),
  icSetting: require("../../assets/icons/Setting-icon.svg"),
  icChat: require("../../assets/icons/Chat-icon.svg"),
  icChatMobile: require("../../assets/icChat.svg"),
  icCloseWhiteSvg: require("../../assets/icons/icCloseWhite.svg"),
  icExpand: require("../../assets/icons/icExpand.svg"),
  icVectorPlus: require("../../assets/icons/icVectorPlus.png"),
  icShareCircle: require("../../assets/icons/icShareCircle.png"),
  icTV: require("../../assets/icons/Event-icon.svg"),
  icTicket: require("../../assets/icons/icTicket.png"),
  icProfile: require("../../assets/icons/Profile-icon.svg"),
  icHome: require("../../assets/icons/Home-Icon.svg"),
  icHelp: require("../../assets/icons/Help-Icon.svg"),
  icHelpMobile: require("../../assets/icons/Help-Icon-Mobile.svg"),
  icnGreenTick: require("../../assets/icons/icnGreenTick.png"),
  icCoin: require("../../assets/icCoin.svg"),
  icGameCapture: require("../../assets/icons/icGameCapture.svg"),
  icEmptyOpponent: require("../../assets/EmptyOpponent.svg"),
  icVsLogo: require("../../assets/vs.svg"),
  icKoDefaultOpponent: require("../../assets/ko-default-opponent.svg"),

  icEyeWhiteOpen: require("../../assets/icons/icEyeWhiteOpen.svg"),
  icEyeWhiteClose: require("../../assets/icons/icEyeWhiteClose.svg"),
  icBrowser: require("../../assets/icons/icBrowser.svg"),
  icDisplayCapture: require("../../assets/icons/icDisplayCapture.svg"),
  icWindowCapture: require("../../assets/icons/icWindowCapture.svg"),
  icImageCapture: require("../../assets/icons/icImageCapture.svg"),
  icCameraWhite: require("../../assets/icons/icCameraWhite.svg"),
  icLockWhite: require("../../assets/icons/icLockWhite.svg"),
  icUnLockWhite: require("../../assets/icons/icUnLockWhite.svg"),
  icWhitePlus: require("../../assets/icons/icWhitePlus.svg"),
  icTrashWhite: require("../../assets/icons/icTrashWhite.svg"),
  icChevronUp: require("../../assets/icons/icChevronUp.svg"),
  icChevronDown: require("../../assets/icons/icChevronDown.svg"),
  icRedCircle: require("../../assets/icons/icRedCircle.svg"),
  icMusic: require("../../assets/icons/icMusic.svg"),
  icSettings: require("../../assets/icons/icSettings.svg"),
  icMicroPhone: require("../../assets/icons/icMicroPhone.svg"),
  icSliderThumb: require("../../assets/icons/icSliderThumb.svg"),
  icSendIcon: require("../../assets/icons/icSendIcon.svg"),
  koSendComment: require("../../assets/ko_send_comment.svg"),
  icExpandChat: require("../../assets/icons/icExpandChat.svg"),
  icUnExpandChat: require("../../assets/icons/icUnExpandChat.svg"),
  percentagePurple: require("../../assets/icons/percentagePurple.svg"),
  doubleArrow: require("../../assets/icons/doubleArrow.svg"),
  walletIcon: require("../../assets/icons/walletIcon.svg"),
  greentick: require("../../assets/icons/greentick.svg"),

  ballImg: require("../../assets/ballImg.png"),
  catImg: require("../../assets/catImg.png"),
  roosterImg: require("../../assets/roosterImg.png"),
  ThumUpImg: require("../../assets/ThumUpImg.png"),
  wolfImg: require("../../assets/wolfImg.png"),
  alarmImg: require("../../assets/alarmImg.png"),
  GiftImg: require("../../assets/GiftImg.png"),
  newGiftImg: require("../../assets/newGiftImg.svg"),
  icForward: require("../../assets/icForward.png"),
  icCamera: require("../../assets/icCamera.png"),
  icVoice: require("../../assets/icVoice.png"),
  icNotification: require("../../assets/icNotification.png"),
  icCaution: require("../../assets/icCaution.svg"),
  icOBS1: require("../../assets/icOBS1.svg"),
  icOBS2: require("../../assets/icOBS2.svg"),
  icOBS3: require("../../assets/icOBS3.png"),
  icOBS4: require("../../assets/icOBS4.svg"),
  icOBS5: require("../../assets/icOBS5.svg"),
  icRTMP1: require("../../assets/icRTMP1.svg"),
  icRTMP2: require("../../assets/icRTMP2.svg"),
  icRTMP3: require("../../assets/icRTMP3.svg"),
  icRTMP4: require("../../assets/icRTMP4.svg"),
  icRTMP5: require("../../assets/icRTMP5.svg"),
  icObsConnection: require("../../assets/icObsConnection.svg"),
  icObsConnectionPin: require("../../assets/icObsConnectionPin.svg"),
  icRtmpIcon: require("../../assets/icRtmpIcon.svg"),
  icCameraPic: require("../../assets/icCamera.svg"),
  icLive: require("../../assets/icLive.svg"),
  icObsStep1: require("../../assets/icObsStep1.svg"),
  icMic: require("../../assets/icMic.svg"),
  icDashboardSpeed: require("../../assets/icDashboardSpeed.svg"),
  icQuality: require("../../assets/icQuality.svg"),
  icLandscape: require("../../assets/icLandscape.svg"),
  icRtmpStep1: require("../../assets/icRtmpStep1.svg"),
  icRtmpStep2: require("../../assets/icRtmpStep2.svg"),
  icRtmpStep3: require("../../assets/icRtmpStep3.svg"),
  icRtmpStep4: require("../../assets/icRtmpStep4.svg"),
  icRtmpStep5: require("../../assets/icRtmpStep5.svg"),
  imgDisputeDetails: require("../../assets/imgDisputeDetails.svg"),
  Ko_Default_event_image: require("../../assets/KO_DEFAULT_EVENT_IAMGE.svg"),

  //gift images
  keepItUp: require("../../assets/keep-it-up.svg"),
  highFive: require("../../assets/high-five.svg"),
  rose: require("../../assets/rose.svg"),
  awesome: require("../../assets/awesome.svg"),
  respect: require("../../assets/respect.svg"),
  wowPow: require("../../assets/wow-pow.svg"),
  magic: require("../../assets/magic.svg"),
  coolDude: require("../../assets/cool-dude.svg"),
  unicorn: require("../../assets/unicorn.svg"),
  realShooter: require("../../assets/real-shooter.svg"),
  goldenBoots: require("../../assets/golden-boots.svg"),
  gladiator: require("../../assets/gladiator.svg"),
  ninja: require("../../assets/ninja.svg"),
  shadow: require("../../assets/shadow.svg"),
  moneyPouch: require("../../assets/money-pouch.svg"),
  crowned: require("../../assets/crowned.svg"),

  //Ellips
  Ellipse1: require("../../assets/Ellipse1.png"),
  Ellipse2: require("../../assets/Ellipse2.png"),
  Ellipse3: require("../../assets/Ellipse3.png"),
  Ellipse4: require("../../assets/Ellipse4.png"),
  Ellipse5: require("../../assets/Ellipse5.png"),

  //Upgrade popup
  BenefitsEarnings: require("../../assets/BenefitsEarnings.png"),
  BenefitsPriority: require("../../assets/BenefitsPriority.png"),
  BenefitsEnhanced: require("../../assets/BenefitsEnhanced.png"),
  BenefitsExclusive: require("../../assets/BenefitsExclusive.png"),
  BenefitsBoosted: require("../../assets/BenefitsBoosted.png"),
  pauseBtn: require("../../assets/pauseBtn.svg"),
  playBtn: require("../../assets/playBtn.svg"),

  //challenge successful popup
  icChallengeLogo: require("../../assets/Challenge-successful/icon.svg"),
  step1: require("../../assets/Challenge-successful/step-1.png"),
  step2: require("../../assets/Challenge-successful/step-2.svg"),
  icAcceptLogo: require("../../assets/Challenge-successful/accept-logo.svg"),

  //Notification popup
  icNotificationLogo: require("../../assets/KO_LOGO_MAIN.svg"),
  icNotificationBarcode: require("../../assets/notification-barcode.svg"),
  icNotificationMessage: require("../../assets/notification-message-icon.svg"),

  //login page
  icMainLogo: require("../../assets/main-logo.svg"),
  icSignupLogo: require("../../assets/signup-logo.svg"),
  icYoutubeLogo: require("../../assets/youtubeLogo.svg"),
  icTwitchLogo: require("../../assets/twitchLogo.svg"),
  icTwitchTextLogo: require("../../assets/icTwitchTextLogo.svg"),
  icBgShadow: require("../../assets/bgShadow.svg"),
  icGoogleLogo: require("../../assets/google-logo.svg"),
  icAppleLogo: require("../../assets/apple-logo.svg"),
  icStreamLogo: require("../../assets/stream-logo.svg"),

  //chooseGame
  icChooseGameLogo: require("../../assets/gameIcon.svg"),

  //Changes Ready to send popup
  icChangesLogo: require("../../assets/icChangesLogo.svg"),
  icArrow: require("../../assets/icArrow.svg"),

  //Events details updated popup
  icEventUpdated: require("../../assets/icEventUpdated.svg"),

  // Changes approved popup
  icChangesApproved: require("../../assets/icChangesApproved.svg"),

  // Changes Rejected popup
  icReject: require("../../assets/icReject.svg"),

  //What are coins popup
  icCalendar: require("../../assets/icCalendar.svg"),
  icCoinsPopupImage: require("../../assets/icCoinsPopupImage.svg"),
  icChallengeIcon: require("../../assets/icChallengeIcon.svg"),
  icEventParticipation: require("../../assets/icEventParticipation.svg"),
  icMillestones: require("../../assets/icMillestones.svg"),
  icEngagment: require("../../assets/icEngagment.svg"),

  UploadIcon: require("../../assets/UploadIcon.svg"),
  tokensIcon: require("../../assets/tokensIcon.svg"),
  icRechargeIcon: require("../../assets/tokensIcon.svg"),
  JosebPlayer: require("../../assets/JosebPlayer.png"),
  mobileViewlogo: require("../../assets/mobileViewLogo.svg"),
  icVsWhite: require("../../assets/icVsWhite.svg"),
  streamingEventBadge: require("../../assets/streamingEventBadge.svg"),

  icAcceptEventPlatformImage: require("../../assets/Accept-Event-Platform-Image.svg"),

  //Events details page icons
  MatchTime: require("../../assets/EventIcons/match_time.svg"),
  CheckInTime: require("../../assets/EventIcons/check_in_time.svg"),
  CheckInTick: require("../../assets/EventIcons/Check_In_Tick.svg"),
  CheckInReady: require("../../assets/EventIcons/ready_check_in.svg"),
  User_Online: require("../../assets/EventIcons/Online_user.svg"),
  Offline_User: require("../../assets/EventIcons/Offline_user.svg"),
  Live_Stream: require("../../assets/EventIcons/Live_stream.svg"),
  Start_stream: require("../../assets/EventIcons/Start_Stream.svg"),
  Stop_Stream: require("../../assets/EventIcons/Stop_Stream.svg"),
  Record_Stream: require("../../assets/EventIcons/Record_Stream.svg"),
  Stop_Recording: require("../../assets/EventIcons/Stop_Recording.svg"),
  Obs_Icon: require("../../assets/EventIcons/Obs_Icon.svg"),
  Toggle_On: require("../../assets/EventIcons/Toggle_On.svg"),
  Toggle_Off: require("../../assets/EventIcons/Toggle_Off.svg"),
  Sources_Edit: require("../../assets/EventIcons/Sources_Edit.svg"),
  Souces_Close: require("../../assets/EventIcons/Souces_Close.svg"),
  Store_Past_Stream: require("../../assets/EventIcons/Store-past-stream.png"),
  Store_past_Stream_White: require("../../assets/EventIcons/Store-past-stream-tooltip.png"),
  icLinkPurple: require("../../assets/link-purple.svg"),
  icKOLogo: require("../../assets/KO-logo.svg"),
  KO_LOGO_Main: require("../../assets/KO_LOGO_MAIN.svg"),

  // Live Stream Action Icons
  Ko_Chat: require("../../assets/Live_Stream_Icons/Ko_Chat.svg"),
  Ko_Gift: require("../../assets/Live_Stream_Icons/Ko_Gift.svg"),
  Ko_Like: require("../../assets/Live_Stream_Icons/Ko_Like.svg"),
  Ko_Share: require("../../assets/Live_Stream_Icons/Ko_Share.svg"),
  Ko_send: require("../../assets/Live_Stream_Icons/Ko_send.svg"),
  Ko_Token: require("../../assets/ko-token-image.svg"),
  Ko_Token_Bonus_Badge: require("../../assets/token+77.svg"),
  Ko_ongoing_edit: require("../../assets/ongogin-event-edit.svg"),
  Ko_ongoing_share: require("../../assets/ongoing-event-share.svg"),
  KO_GAMESCREEN_CHAT_Icon: require("../../assets/KO_GAMESCREEN_CHAT_Icon.svg"),
  Ko_Coin: require("../../assets/ko-coin-image.png"),
  Ko_Stripe: require("../../assets/ko-stripe-image.svg"),
  ko_diamond: require("../../assets/ko-daimond-image.svg"),

  // Checkbox icons for influencer modal
  icCheckboxNotSelected: require("../../assets/Check-icon-not-selected.svg"),
  icCheckboxSelected: require("../../assets/Check-icon-selected.svg"),

  // Past Event Icons
  icVictoryCrown: require("../../assets/pastevent/Victory-crown.svg"),
  icPlayedGames: require("../../assets/pastevent/played-games.svg"),
  icGamesLost: require("../../assets/pastevent/games-lost.svg"),
  icGamesWon: require("../../assets/pastevent/Games-won.svg"),
  icTokenEarned: require("../../assets/pastevent/token-earned.svg"),
  icGiftEvent: require("../../assets/pastevent/gift-event.svg"),
  icLikeEvent: require("../../assets/pastevent/Like-event.svg"),
};
